/* file description */
// import { compose } from '@cui/corteza-js';
import { message } from 'antd';
import { useEffect, useState } from 'react';
import { getAssetModuleByRequest } from '@/common/asset-apis/getAssetModuleByRequest';

import { ModuleInfo } from '@/common/model-apis/type';
import type { UseModule } from './type';

/**
 * @ComposeAPI 判断是老低代码的接口还是新的数据资产的接口
 */

export const useModule: UseModule = ({ assetModuleInfo, moduleID, namespaceID, FetchAPI }) => {
  const [moduleInfo, setModuleInfo] = useState<ModuleInfo>({});
  useEffect(() => {
    getAssetModuleByRequest({ FetchAPI, namespaceID, moduleID, assetModuleInfo })
      ?.then((res) => {
        setModuleInfo(res);
      })
      .catch((error) => {
        message.error(error.message || error.msg || `加载module失败，moduleID: ${moduleID}`);
      });
  }, [assetModuleInfo, moduleID]);
  return {
    moduleInfo,
  };
};
